module.exports = __webpack_public_path__ + "static/media/Fraser Mathews.355582bf.jpg";